import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { notifyAuthPost } from '../../../../api-client/api-gqnotification-client';

const initialState = {
    loading: false,
    error: null,
    data: null,
};

export const postNotifyAuthAuthorize = createAsyncThunk(
    'postNotifyAuthAuthorize/Post',
    async (body, { rejectWithValue }) => {
        try {
            const response = await notifyAuthPost(body);
            const data = response.data;
            return data;
        } catch (err) {
            const errObj = {
                type: 'POST_GQ_NOTIFY_AUTH_FAILURE',
                error: err,
            };
            return rejectWithValue(err?.response?.data || errObj);
        }
    },
);

export const postNotifyAuthAuthorizeSlice = createSlice({
    name: 'postNotifyAuthAuthorize',
    initialState,
    extraReducers: {
        [postNotifyAuthAuthorize.pending]: (state) => {
            state.loading = true;
        },
        [postNotifyAuthAuthorize.fulfilled]: (state, { payload }) => {
            state.loading = false;
            state.data = payload?.data;
        },
        [postNotifyAuthAuthorize.rejected]: (state, { payload }) => {
            state.loading = false;
            state.data = null;
            state.error = payload;
        },
    },
});

export const postNotifyAuthAuthorizeSelector = (state) => state.postNotifyAuthAuthorize;
export const postNotifyAuthAuthorizeReducer = postNotifyAuthAuthorizeSlice.reducer;
